<form
    #ngForm="ngForm"
    (ngSubmit)="validate()">
    <div class="grid">
        <div class="grid__unit s-4-4 m-12-12 l-8-12 l-push-left-1-12">
            <section class="richText">
                <h1>{{ 'LANDINGS-PAGE.TITLE' | translate }}</h1>
                <app-error
                    [show]="errorDetails.show"
                    [textOrKey]="errorDetails.textOrKey">
                </app-error>
                <p>{{ 'LANDINGS-PAGE.INFO' | translate }}</p>
            </section>
            <section>
                <div class="grid">
                    <div class="grid__unit s-4-4 m-12-12 l-12-12">
                        <div class="formfield">
                            <label
                                class="formfield__label"
                                for="cardNumber">
                                {{ 'LANDINGS-PAGE.CARDNUMBER' | translate }} *
                            </label>
                            <div class="formfield__inputContainer__inline">
                                <input
                                    cardValidator
                                    maxlength="25"
                                    [(ngModel)]="cardDetails.engravedId"
                                    name="cardNumber"
                                    type="text"
                                    class="textInput inputSpacer__input inputSpacer__input--input"
                                    id="cardNumber"
                                    #cardNumberInput="ngModel"
                                    required>
                                <app-tool-tip [translateKey]="'LANDINGS-PAGE.TOOLTIP.CARDNUMBER'"></app-tool-tip>
                            </div>
                            <div class="formfield__inputContainer">
                                <app-input-error
                                    id="cardNumberError"
                                    [translateKey]="'LANDINGS-PAGE.ERROR.CARDNUMBER'"
                                    [show]="ngForm.submitted && cardNumberInput.invalid && cardNumberInput.hasError('invalidCardNumber') && (cardNumberInput.touched && cardNumberInput.dirty)">
                                </app-input-error>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="formfield">
                    <label
                        class="formfield__label"
                        for="refNumber">
                        {{ 'LANDINGS-PAGE.REFNUMBER' | translate }} *
                    </label>
                    <div class="formfield__inputContainer__inline">
                        <input
                            [(ngModel)]="cardDetails.ref"
                            name="refNumber"
                            type="text"
                            class="textInput textInput--ovChipkaart"
                            id="refNumber"
                            minlength="7"
                            maxlength="10"
                            #refNumberInput="ngModel"
                            required>
                        <app-tool-tip [translateKey]="'LANDINGS-PAGE.TOOLTIP.REFNUMBER'"></app-tool-tip>
                    </div>
                    <div class="formfield__inputContainer">
                        <app-input-error
                        id="refNumberError"
                            [translateKey]="'LANDINGS-PAGE.ERROR.REFNUMBER'"
                            [show]="ngForm.submitted && refNumberInput.invalid && (refNumberInput.touched && refNumberInput.dirty)">
                        </app-input-error>
                    </div>
                </div>
            </section>
        </div>
    </div>
    <div class="grid">
        <div class="grid__unit s-4-4 m-12-12 l-10-12 l-push-left-1-12">
            <div class="actionBar actionBar--atArticleBottom">
                <div class="actionBar__container actionBar__container--right">
                    <div
                        *ngIf="isLoading"
                        class="basicLoader"></div>
                    <button
                        *ngIf="!isLoading"
                        [relay42]="{ name: 'verder-gaan-knop' }"
                        type="submit"
                        class="button button--arrowRight button--secondary actionBar__item">
                        {{ 'GENERAL.BUTTON.CONTINUE' | translate }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</form>
